export const categoryData = [
  { ttk: false, value: 0, label: "เขตชุมชน" },
  { ttk: false, value: 1, label: "จำกัดความเร็ว" },
  { ttk: false, value: 2, label: "พื้นที่เสี่ยง" },
  { ttk: true, value: 3, label: "จักรยานยนต์วิ่งสวนทาง" },
  { ttk: true, value: 4, label: "งานก่อสร้าง" },
  { ttk: true, value: 5, label: "จุดกลับรถ" },
  { ttk: true, value: 6, label: "เคยเกิดอุบัติเหตุ" },
  { ttk: true, value: 7, label: "สภาพถนนอันตราย" },
  { ttk: true, value: 8, label: "ผิวถนนชำรุด" },
  { ttk: true, value: 9, label: "ทางร่วม ทางแยก" },
  { ttk: true, value: 10, label: "ทางออกด่านเก็บเงิน" },
  { ttk: true, value: 11, label: "ถนนสวนเลน" },
  { ttk: true, value: 12, label: "น้ำท่วมสูง" },
  { ttk: true, value: 13, label: "คอสะพานข้าม" },
  { ttk: true, value: 14, label: "ทางแคบ" },
  { ttk: true, value: 15, label: "ตำรวจตั้งด่านตรวจ" },
  { ttk: true, value: 16, label: "รถบรรทุกพลิกคว่ำ" },
  { ttk: true, value: 17, label: "ซ่อมผิวถนน" },
  { ttk: true, value: 18, label: "ซ่อมเสาไฟฟ้า" },
  { ttk: true, value: 19, label: "เกิดอุบัติเหตุรถชน" },
  { ttk: true, value: 20, label: "แจ้งเตือนเฝ้าระวังน้ำท่วม" },
  { ttk: true, value: 21, label: "รถติดหนัก" },
  { ttk: true, value: 22, label: "ยกสะพานลอย" },
  { ttk: true, value: 23, label: "เกิดเหตุไฟไหม้" },
  { ttk: true, value: 24, label: "มีฝนตก" },
  { ttk: true, value: 25, label: "ปฏิบัติงานตามขั้นตอนทุกครั้ง" },
  { ttk: true, value: 26, label: "ลดความเร็วในพื้นที่ทำงาน" },
  //{ ttk: true, value: 27, label: "พื้นที่เสี่ยงต่อการง่วงนอน" },
];

categoryData.sort((a, b) => (a.label > b.label ? 1 : -1));

export const getCategoryName = (value) => {
  /*if (value === 2) {
    return "พื้นที่เสี่ยง";
  }*/
  return categoryData.find((a) => a.value === value)?.label ?? "";
};

export const alarmData = [
  {
    value: 0,
    label: "พื้นที่ชุมชนจำกัดความเร็ว 30 กม/ชม.",
    soundPath: "/sounds/1.mp3",
    category: [0],
  },
  {
    value: 1,
    label: "พื้นที่ชุมชนจำกัดความเร็ว 40 กม/ชม.",
    soundPath: "/sounds/2.mp3",
    category: [0],
  },
  /*{
    value: 2,
    label: "พื้นที่ชุมชนจำกัดความเร็ว 45 กม/ชม.",
    soundPath: "/sounds/3.mp3",
    category: [0],
  },
  {
    value: 3,
    label: "พื้นที่ชุมชนจำกัดความเร็ว 50 กม/ชม.",
    soundPath: "/sounds/4.mp3",
    category: [0],
  },
  {
    value: 4,
    label: "พื้นที่ชุมชนจำกัดความเร็ว 60 กม/ชม.",
    soundPath: "/sounds/5.mp3",
    category: [0],
  },*/
  {
    value: 5,
    label: "ความเร็วเกินกำหนด",
    soundPath: "/sounds/20.mp3",
    category: [1],
  },
  /*{
    value: 6,
    label: "ความเร็วเกินกำหนด 30 กม/ชม.",
    soundPath: "/sounds/9.mp3",
    category: [1],
  },
  {
    value: 7,
    label: "ความเร็วเกินกำหนด 40 กม/ชม.",
    soundPath: "/sounds/10.mp3",
    category: [1],
  },
  {
    value: 8,
    label: "ความเร็วเกินกำหนด 45 กม/ชม.",
    soundPath: "/sounds/11.mp3",
    category: [1],
  },
  {
    value: 9,
    label: "ความเร็วเกินกำหนด 50 กม/ชม.",
    soundPath: "/sounds/6.mp3",
    category: [1],
  },*/
  {
    value: 10,
    label: "ความเร็วเกินกำหนด 60 กม/ชม.",
    soundPath: "/sounds/7.mp3",
    category: [1],
  },
  /*{
    value: 11,
    label: "ความเร็วเกินกำหนด 75 กม/ชม.",
    soundPath: "/sounds/8.mp3",
    category: [1],
  },*/
  {
    value: 12,
    label: "ความเร็วเกินกำหนด 80 กม/ชม.",
    soundPath: "/sounds/12.mp3",
    category: [1],
  },
  {
    value: 13,
    label: "ความเร็วเกินกำหนด 90 กม/ชม.",
    soundPath: "/sounds/13.mp3",
    category: [1],
  },
  {
    value: 14,
    label: "จอดรถพื้นที่เสี่ยง / จอดไหล่ทาง",
    soundPath: "/sounds/21.mp3",
    category: [
      2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26,
    ],
  },
  {
    value: 15,
    label: "ทางร่วม / ทางแยก",
    soundPath: "/sounds/22.mp3",
    category: [
      2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26,
    ],
  },
  {
    value: 16,
    label: "สี่แยกไฟแดง",
    soundPath: "/sounds/23.mp3",
    category: [
      2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26,
    ],
  },
  {
    value: 17,
    label: "เตือนกิ่งไม้",
    soundPath: "/sounds/30.mp3",
    category: [
      2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26,
    ],
  },
  {
    value: 18,
    label: "เขตก่อสร้างโปรดระวัง",
    soundPath: "/sounds/31.mp3",
    category: [2],
  },
  {
    value: 19,
    label: "จุดเกิดอุบัติเหตุบ่อยโปรดระวัง",
    soundPath: "/sounds/32.mp3",
    category: [2],
  },
  {
    value: 20,
    label: "ทางลาดชันโปรดระวัง",
    soundPath: "/sounds/33.mp3",
    category: [2],
  },
  {
    value: 21,
    label: "พื้นที่เสี่ยงโปรดระวัง",
    soundPath: "/sounds/34.mp3",
    category: [2],
  },
  {
    value: 22,
    label: "ไฟแดงห้ามผ่าไฟแดงเด็ดขาด",
    soundPath: "/sounds/35.mp3",
    category: [2],
  },
  {
    value: 23,
    label: "เสี่ยงต่อการง่วงนอน หยุดพักเพื่อป้องกันอุบัติเหตุ",
    soundPath: "/sounds/36.mp3",
    category: [2],
  },
  {
    value: 24,
    label: "กำลังเข้าจุดอันตรายโปรดใช้ความระมัดระวังในการขับขี่",
    soundPath: "/sounds/29.mp3",
    category: [2],
  },
];
